import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import LogisticsForm from 'ui-shared/Forms/LogisticsForm'
import { Edit } from 'react-admin'

const LogisticstEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <LogisticsForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default LogisticstEdit
